import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { NoSpacesPipe } from '../pipes/noSpaces.pipe';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[phone]',
})
export class PhoneDirective implements OnChanges {
  @Input('phone') phoneNumber: string | undefined;
  private readonly mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  private isMobile: boolean | undefined;

  constructor(
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2,
    private readonly noSpacesPipe: NoSpacesPipe
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['phoneNumber']) {
      this.updatePhoneNumber();
    }
  }

  private updatePhoneNumber() {
    this.isMobile = this.detectMobileDevice();
    if (!this.isMobile) {
      this.renderer.removeAttribute(this.elementRef.nativeElement, 'href');
    } else {
      if (this.phoneNumber) {
        const cleanedPhoneNumber = this.noSpacesPipe.transform(
          this.phoneNumber
        );
        this.renderer.setAttribute(
          this.elementRef.nativeElement,
          'href',
          `tel:${cleanedPhoneNumber}`
        );
      }
    }
  }

  private detectMobileDevice(): boolean {
    return (
      this.mobileRegex.test(navigator.userAgent) || navigator.maxTouchPoints > 0
    );
  }
}
